export const version = '1.10.12';
//# sourceMappingURL=version.js.map